import React from 'react';

import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { MagnifyIcon } from 'assets/icons';

interface DeviceListEmptyStateProps {
  onClearFilters: () => void;
}

export const DeviceListEmptyState = ({ onClearFilters }: DeviceListEmptyStateProps) => {
  const intl = useIntl();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center rounded py-5 bg-light"
      data-test="device-empty-state"
    >
      <MagnifyIcon className="icon mb-3 text-secondary" style={{ fontSize: '32px' }} />
      <p className="mb-1 fw-medium">{intl.formatMessage({ id: 'deviceListNoResultsTitleKey' })}</p>
      <p className="mb-3 text-secondary small">
        {intl.formatMessage({ id: 'deviceListNoResultsDescKey' })}
      </p>
      <Button
        type="button"
        variant="primary"
        size="sm"
        onClick={onClearFilters}
        data-test="device-clear-filters"
      >
        {intl.formatMessage({ id: 'deviceClearFiltersKey' })}
      </Button>
    </div>
  );
};
